// Temporary permissions utility - to be replaced with proper permission checking later
export const PERMISSIONS = {
  // Newsfeed permissions
  NEWSFEED_EDIT: false,
  NEWSFEED_DELETE: false,
  NEWSFEED_CREATE: true,

  // General permissions
  ADMIN_ACCESS: true,
  USER_MANAGEMENT: true,

  // Chapter permissions
  CHAPTER_MANAGEMENT: true,
  CHAPTER_EDIT: true,

  // Member permissions
  MEMBER_MANAGEMENT: true,
  MEMBER_EDIT: true,
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;

export const hasPermission = (permission: PermissionKey): boolean => {
  return PERMISSIONS[permission];
};

export const checkMultiplePermissions = (
  permissions: PermissionKey[]
): boolean => {
  return permissions.every((permission) => PERMISSIONS[permission]);
};
